<template>
  <v-card>
    <div>
      <div class="title-bar d-flex justify-space-between">
        <div>
          <div class="title">
            {{article.name}}
          </div>
          <div class="subtitle">
            {{article.description}}
          </div>
        </div>
        <div>
          <ButtonActionEdit v-if="editable" @click="$emit('edit')" />
          <ButtonActionDuplicate v-if="duplicatable" @click="$emit('duplicate')" />
          <ButtonActionDelete @click="$emit('delete')" />
        </div>
      </div>
      <v-card-text>
        <v-row>
          <div class="user-card-label">
            Cena
          </div>
          <div class="user-card-value">
            {{article.price | price}} €
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label">
            Skupina
          </div>
          <div class="user-card-value">
            {{article.category_name}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label">
            Grupa
          </div>
          <div class="user-card-value">
            ({{article.tax_level_value}}%) {{article.group_name}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label">
            Artikel se prodaja
          </div>
          <div class="user-card-value">
            <ActiveIcon :value="article.is_visible" />
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label">
            Vodi se zaloga
          </div>
          <div class="user-card-value">
            <ActiveIcon :value="article.inventory_kept" />
          </div>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import ButtonActionEdit from './ButtonActionEdit'
import ButtonActionDuplicate from './ButtonActionDuplicate'
import ButtonActionDelete from './ButtonActionDelete'
import ActiveIcon from './ActiveIcon'

export default {
  components: {
    ButtonActionEdit,
    ButtonActionDuplicate,
    ButtonActionDelete,
    ActiveIcon
  },
  props: {
    editable: {
      default: true,
      type: Boolean
    },
    duplicatable: {
      default: false,
      type: Boolean
    },
    article: {
      required: true,
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-card {
    padding: 20px;
  }
  .title-bar {
    padding: 10px;
    padding-bottom: 20px;
    box-shadow: 0 4px 3px -5px #455A64;

    .title {
      font-size: 22px;
      font-weight: bold;
      color: #607D8B;
    }
    .subtitle {
      color: #B0BEC5;
      font-size: 12px;
    }
  }
  .v-card__text {
    .col {
      padding: 6px 12px;
    }
    .user-card-label {
      min-width: 120px;
      color: #BDBDBD;
    }
    .user-card-value {
      color: #607D8B;
      font-weight: bold;
    }
  }
</style>
